// https://d4gvk4mvh9ktn.cloudfront.net/[bucket-name]/[asset-name]

export const url_base = "https://d4gvk4mvh9ktn.cloudfront.net";

export function getCloudFrontVideo(foldername, filename){
    return url_base + '/' + foldername + '/' + filename;
}